import { intlGet } from 'utils/intlGet';

export enum ImageSizeType {
  HEIGHT = 'height',
  WIDTH = 'width',
}

export const MIN_IMAGE_WIDTH = 1;
export const DEFAULT_IMAGE_ALT_TAG = intlGet('Image', 'DefaultAltTag');
